import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'tui-calendar/dist/tui-calendar.css';
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import { FaTimes, FaCheck } from 'react-icons/fa';
import { TIPO_ATIVIDADE, STATUS_CODE_OK } from '~/constant';
import ModalAtividade from '../../ProspectoDetalhes/ModalAtividades';
import FormularioVisita from '~/Components/FormularioVisita';
import FormularioTarefas from '~/Components/FormularioTarefas';
import '../agenda.css';
import Loading from '~/Components/Loading';

export default function ListaAtividadesAgenda({
  atividadesFiltradas,
  loading,
  reconstruirAtividades,
}) {
  const [modalEdicaoTipo, setModalEdicaoTipo] = useState(null);
  const [atividadeEditando, setAtividadeEditando] = useState(null);
  const [salvandoDados, setSalvandoDados] = useState();

  const SITUACAO = {
    PENDENTE: 'Pendente',
    CONCLUIDO: 'Concluído',
    EM_ANDAMENTO: 'Em Andamento',
    CANCELADO: 'Cancelado',
    VENCIDO: 'Vencido',
  };

  const fecharModais = () => {
    setModalEdicaoTipo(null);
    setAtividadeEditando(null);
  };

  const atividadeEtapaStringToEnum = situacao => {
    switch (situacao) {
      case 'Pendente':
        return 1;
      case 'Concluído':
        return 2;
      case 'Em Andamento':
        return 3;
      case 'Cancelado':
        return 4;
      case 'Vencido':
        return 5;
    }
  };

  const cancelarAtividade = dados => {
    let atividadeObj = JSON.parse(dados.atividade);
    atividadeObj.situacao = SITUACAO.CANCELADO;
    dados.descricao_atividade = JSON.stringify(atividadeObj);
    dados.atividade_etapa = atividadeEtapaStringToEnum('Cancelado');
    dados.codigo_responsavel = dados.codigo_usuario_responsavel;

    editarFormulario(dados);
  };

  const concluirAtividade = dados => {
    let atividadeObj = JSON.parse(dados.atividade);
    atividadeObj.situacao = SITUACAO.CONCLUIDO;
    dados.descricao_atividade = JSON.stringify(atividadeObj);
    dados.atividade_etapa = atividadeEtapaStringToEnum('Concluído');
    dados.codigo_responsavel = dados.codigo_usuario_responsavel;

    editarFormulario(dados);
  };

  const HandlereconstruirAtividades = response => {
    if (!response || !response.nova_atividade) return;
    reconstruirAtividades(response);
  };

  const editarModalFormulario = async (dados, tipoAtividade) => {
    var request = {
      tipo_atividade: tipoAtividade,
      atividade_etapa: atividadeEtapaStringToEnum(dados.situacao),
      descricao_atividade: JSON.stringify(dados),
      codigo_atividade: dados.codigoAtividade,
      data_conclusao: dados.data,
      codigo_responsavel: dados.responsavel.split('-')[0].trim(),
    };
    editarFormulario(request);
  };

  const editarFormulario = async dados => {
    try {
      setSalvandoDados(true);
      var request = {
        ...dados,
      };

      let response = await api.editarAtividade(request);

      if (response.status === STATUS_CODE_OK) {
        fecharModais();
        toast.success(`Atividade editada com sucesso.`);
        HandlereconstruirAtividades(response);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSalvandoDados(false);
    }
  };

  function getTipoAtividadeTexto(tipo) {
    switch (tipo) {
      case TIPO_ATIVIDADE.ANOTACAO:
        return 'uma anotação';
      case TIPO_ATIVIDADE.EMAIL:
        return 'um E-mail';
      case TIPO_ATIVIDADE.SMS:
        return 'um SMS';
      default:
        return 'uma atividade';
    }
  }

  const getSituacaoColor = situacao => {
    const situacaoColors = {
      Pendente: '#f8d377ff',
      Concluído: '#85f08bff',
      'Em Andamento': '#7ab6f3ff',
      Cancelado: '#fc817fff',
      Vencido: '#fc817fff',
    };
    return situacaoColors[situacao] || '#757575';
  };

  const getPrioridadeColor = prioridade => {
    if (prioridade === 'Alta') return '#ef3f56';
    if (prioridade === 'Normal') return '#fbc02d';
    if (prioridade === 'Baixa') return '#419aef';
    return '#757575';
  };

  return (
    <>
      <Card style={{ border: 'none', boxShadow: 'none', display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
          {!loading &&
            (!atividadesFiltradas || atividadesFiltradas.length <= 0) && (
              <div className="centered-empty-state">
                <div className="empty-state-card">
                  <div className="titulo-empty-state-agenda">
                    Não existe tarefa para este dia
                  </div>
                  <div
                    style={{
                      color: '#b0b0b0',
                      fontSize: 15,
                      marginBottom: 24,
                    }}
                  >
                    Novas tarefas devem ser criadas
                    <br />a partir de um lead.
                  </div>
                  <Button
                    className="btn-gestao-leads"
                    variant="teal"
                    onClick={() => (window.location.href = '/prospectos')}
                  >
                    Ir para gestão de leads
                  </Button>
                </div>
              </div>
            )}
          {loading && (
            <div className="loading-container">
              <Loading label="Carregando agenda..." />
            </div>
          )}

          <div className="div-scroll-agenda">
            {atividadesFiltradas &&
              atividadesFiltradas.length > 0 &&
              atividadesFiltradas.map((atividade, index) => {
                const atividadeDetalheObj = JSON.parse(atividade.atividade);
                return (
                  <Card
                    className="mb-2"
                    key={index}
                    style={{ border: '1px solid #e9ecef' }}
                  >
                    <Card.Body
                      style={{
                        background: '#fafbfc',
                        borderRadius: 8,
                        padding: '10px 16px',
                      }}
                    >
                      {/* ===== VERSÃO MOBILE ===== */}
                      <div className="d-block d-md-none">
                        {/* Header mobile: horário + tipo + status */}
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div className="d-flex flex-column align-items-start">
                            <div
                              className="data-atividade-agenda"
                              style={{ fontSize: 16, fontWeight: 700 }}
                            >
                              {atividadeDetalheObj.data
                                ? (() => {
                                    const data = new Date(
                                      atividadeDetalheObj.data
                                    );
                                    const hora = data
                                      .getHours()
                                      .toString()
                                      .padStart(2, '0');
                                    const minutos = data
                                      .getMinutes()
                                      .toString()
                                      .padStart(2, '0');
                                    return hora + ':' + minutos;
                                  })()
                                : '--'}
                            </div>
                            <div
                              style={{
                                fontSize: 12,
                                color: '#6c757d',
                                marginTop: 2,
                              }}
                            >
                              {atividade.descricao_tipo_atividade}
                            </div>
                            <span
                              className="badge text-white fw-semibold mt-1"
                              style={{
                                backgroundColor: getSituacaoColor(
                                  atividadeDetalheObj.situacao
                                ),
                                fontSize: 10,
                                padding: '4px 8px',
                                borderRadius: 4,
                              }}
                            >
                              {atividadeDetalheObj.situacao}
                            </span>
                          </div>

                          <div
                            className="d-flex flex-column align-items-end"
                            style={{ gap: 6 }}
                          >
                            <Button
                              size="sm"
                              variant="outline-primary"
                              className="fw-bold px-3"
                              style={{ fontSize: 12 }}
                              onClick={() => {
                                setAtividadeEditando(atividade);
                                setModalEdicaoTipo(atividade.tipo_atividade);
                              }}
                            >
                              Ver Detalhes
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-warning"
                              className="fw-bold px-3"
                              style={{ fontSize: 12 }}
                              onClick={() => {
                                window.location.href = `/prospecto/gestao-crm/${atividade.codigo_prospecto}`;
                              }}
                            >
                              Ver Lead
                            </Button>
                            <div className="d-flex gap-2">
                              <Button
                                size="sm"
                                variant="light"
                                className="d-flex align-items-center justify-content-center border-0 btn-edicao"
                                style={{ width: 28, height: 28 }}
                                title="Cancelar"
                                disabled={
                                  salvandoDados ||
                                  atividadeDetalheObj.situacao ===
                                    'Cancelado' ||
                                  atividadeDetalheObj.situacao === 'Concluído'
                                }
                                onClick={() => cancelarAtividade(atividade)}
                              >
                                <FaTimes size={12} color="#f84946ff" />
                              </Button>
                              <Button
                                size="sm"
                                variant="light"
                                className="d-flex align-items-center justify-content-center border-0 btn-edicao"
                                style={{ width: 28, height: 28 }}
                                title="Concluir"
                                disabled={
                                  salvandoDados ||
                                  atividadeDetalheObj.situacao === 'Concluído'
                                }
                                onClick={() => concluirAtividade(atividade)}
                              >
                                <FaCheck size={12} color="#48ee50ff" />
                              </Button>
                            </div>
                          </div>
                        </div>

                        {/* Informações mobile */}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                          }}
                        >
                          {atividadeDetalheObj.prioridade && (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                              }}
                            >
                              <div
                                style={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: '50%',
                                  background: getPrioridadeColor(
                                    atividadeDetalheObj.prioridade
                                  ),
                                }}
                              ></div>
                              <small style={{ color: '#495057' }}>
                                {atividadeDetalheObj.prioridade}
                              </small>
                            </div>
                          )}
                          {atividade.atividade_vinculada &&
                            atividade.atividade_vinculada.codigo_atividade >
                              0 && (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 6,
                                }}
                              >
                                <div
                                  style={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: '50%',
                                    background: '#ef3f56',
                                  }}
                                ></div>
                                <small
                                  style={{ fontSize: 11, color: '#757575' }}
                                >
                                  Possui{' '}
                                  {getTipoAtividadeTexto(
                                    atividade.atividade_vinculada.tipo_atividade
                                  )}
                                </small>
                              </div>
                            )}
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              lineHeight: 1.5,
                            }}
                          >
                            <span style={{ color: '#495057', fontWeight: 600 }}>
                              Lead:{' '}
                            </span>
                            {atividade.codigo_prospecto +
                              ' - ' +
                              atividade.nome_prospecto}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              lineHeight: 1.5,
                            }}
                          >
                            <span style={{ color: '#495057', fontWeight: 600 }}>
                              Descrição:{' '}
                            </span>
                            {atividadeDetalheObj.descricao}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              lineHeight: 1.5,
                            }}
                          >
                            <span style={{ color: '#495057', fontWeight: 600 }}>
                              Responsável:{' '}
                            </span>
                            {atividadeDetalheObj.responsavel}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              lineHeight: 1.5,
                            }}
                          >
                            <span style={{ color: '#495057', fontWeight: 600 }}>
                              Interesse do lead:{' '}
                            </span>
                            {atividade.nome_empreendimento}
                          </div>
                        </div>
                      </div>

                      {/* ===== VERSÃO DESKTOP ===== */}
                      <div
                        className="d-none d-md-flex align-items-center w-100"
                        style={{ gap: 16 }}
                      >
                        {/* Coluna esquerda: Horário + Tipo + Status */}
                        <div
                          className="d-flex flex-column align-items-center"
                          style={{ minWidth: 80 }}
                        >
                          <div
                            style={{
                              fontSize: 16,
                              fontWeight: 700,
                              color: '#2c3e50',
                            }}
                          >
                            {atividadeDetalheObj.data
                              ? (() => {
                                  const data = new Date(
                                    atividadeDetalheObj.data
                                  );
                                  const hora = data
                                    .getHours()
                                    .toString()
                                    .padStart(2, '0');
                                  const minutos = data
                                    .getMinutes()
                                    .toString()
                                    .padStart(2, '0');
                                  return hora + ':' + minutos;
                                })()
                              : '--'}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              marginTop: 2,
                            }}
                          >
                            {atividade.descricao_tipo_atividade}
                          </div>
                          <span
                            className="badge text-white fw-semibold mt-1"
                            style={{
                              backgroundColor: getSituacaoColor(
                                atividadeDetalheObj.situacao
                              ),
                              fontSize: 10,
                              padding: '4px 10px',
                              borderRadius: 4,
                            }}
                          >
                            {atividadeDetalheObj.situacao}
                          </span>
                        </div>

                        {/* Linha vertical separadora */}
                        <div
                          style={{
                            width: 1,
                            height: 70,
                            backgroundColor: '#e0e0e0',
                          }}
                        ></div>

                        {/* Coluna central: Informações */}
                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6,
                          }}
                        >
                          {/* Indicadores */}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 16,
                              marginBottom: 2,
                            }}
                          >
                            {atividadeDetalheObj.prioridade && (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 6,
                                }}
                              >
                                <div
                                  style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: getPrioridadeColor(
                                      atividadeDetalheObj.prioridade
                                    ),
                                  }}
                                ></div>
                                <small
                                  style={{ color: '#495057', fontSize: 12 }}
                                >
                                  {atividadeDetalheObj.prioridade}
                                </small>
                              </div>
                            )}
                            {atividade.atividade_vinculada &&
                              atividade.atividade_vinculada.codigo_atividade >
                                0 && (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 6,
                                      height: 6,
                                      borderRadius: '50%',
                                      background: '#ef3f56',
                                    }}
                                  ></div>
                                  <small
                                    style={{ fontSize: 11, color: '#ef3f56' }}
                                  >
                                    Possui{' '}
                                    {getTipoAtividadeTexto(
                                      atividade.atividade_vinculada
                                        .tipo_atividade
                                    )}
                                  </small>
                                </div>
                              )}
                          </div>

                          {/* Informações do Lead */}
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              lineHeight: 1.6,
                            }}
                          >
                            <span style={{ color: '#495057', fontWeight: 600 }}>
                              Lead:{' '}
                            </span>
                            {atividade.codigo_prospecto +
                              ' - ' +
                              atividade.nome_prospecto}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              lineHeight: 1.6,
                            }}
                          >
                            <span style={{ color: '#495057', fontWeight: 600 }}>
                              Descrição:{' '}
                            </span>
                            {atividadeDetalheObj.descricao}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              lineHeight: 1.6,
                            }}
                          >
                            <span style={{ color: '#495057', fontWeight: 600 }}>
                              Responsável:{' '}
                            </span>
                            {atividadeDetalheObj.responsavel}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: '#6c757d',
                              lineHeight: 1.6,
                            }}
                          >
                            <span style={{ color: '#495057', fontWeight: 600 }}>
                              Interesse do lead:{' '}
                            </span>
                            {atividade.nome_empreendimento}
                          </div>
                        </div>

                        {/* Coluna direita: Botões */}
                        <div
                          className="d-flex flex-column align-items-end"
                          style={{ gap: 8, minWidth: 110 }}
                        >
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="fw-bold px-3"
                            style={{ fontSize: 12, whiteSpace: 'nowrap' }}
                            onClick={() => {
                              setAtividadeEditando(atividade);
                              setModalEdicaoTipo(atividade.tipo_atividade);
                            }}
                          >
                            Ver Detalhes
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-warning"
                            className="fw-bold px-3"
                            style={{ fontSize: 12, whiteSpace: 'nowrap' }}
                            onClick={() => {
                              window.location.href = `/prospecto/gestao-crm/${atividade.codigo_prospecto}`;
                            }}
                          >
                            Ver Lead
                          </Button>
                          <div className="d-flex gap-2">
                            <Button
                              size="sm"
                              variant="light"
                              className="d-flex align-items-center justify-content-center border-0 btn-edicao"
                              style={{ width: 30, height: 30 }}
                              title="Cancelar"
                              disabled={
                                salvandoDados ||
                                atividadeDetalheObj.situacao === 'Cancelado' ||
                                atividadeDetalheObj.situacao === 'Concluído'
                              }
                              onClick={() => cancelarAtividade(atividade)}
                            >
                              <FaTimes size={14} color="#f84946ff" />
                            </Button>
                            <Button
                              size="sm"
                              variant="light"
                              className="d-flex align-items-center justify-content-center border-0 btn-edicao"
                              style={{ width: 30, height: 30 }}
                              title="Concluir"
                              disabled={
                                salvandoDados ||
                                atividadeDetalheObj.situacao === 'Concluído'
                              }
                              onClick={() => concluirAtividade(atividade)}
                            >
                              <FaCheck size={14} color="#48ee50ff" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                );
              })}
          </div>
      </Card>
      {modalEdicaoTipo &&
        (() => {
          switch (modalEdicaoTipo) {
            case TIPO_ATIVIDADE.TAREFA:
              return (
                <ModalAtividade
                  show={atividadeEditando}
                  onHide={() => {
                    setModalEdicaoTipo(null);
                    setAtividadeEditando(null);
                  }}
                  titulo="Editar Atividade - Tarefa"
                  salvando={salvandoDados}
                  codigo_prospecto={atividadeEditando.codigo_prospecto}
                  componente={
                    <FormularioTarefas
                      onSubmit={values =>
                        editarModalFormulario(
                          values,
                          TIPO_ATIVIDADE.TAREFA,
                          true
                        )
                      }
                      initialValues={{
                        ...JSON.parse(atividadeEditando.atividade),
                        codigoAtividade: atividadeEditando.codigo_atividade,
                      }}
                      modoEdicao={true}
                      readOnly={true}
                      closeModal={() => {
                        setModalEdicaoTipo(null);
                        setAtividadeEditando(null);
                      }}
                      atividadeVinculada={
                        atividadeEditando.atividade_vinculada || ''
                      }
                    />
                  }
                />
              );
            case TIPO_ATIVIDADE.VISITA:
              return (
                <ModalAtividade
                  show={atividadeEditando}
                  onHide={() => {
                    setModalEdicaoTipo(null);
                    setAtividadeEditando(null);
                  }}
                  titulo="Editar Atividade - Visita"
                  salvando={salvandoDados}
                  codigo_prospecto={atividadeEditando.codigo_prospecto}
                  componente={
                    <FormularioVisita
                      onSubmit={values =>
                        editarModalFormulario(
                          values,
                          TIPO_ATIVIDADE.VISITA,
                          true
                        )
                      }
                      initialValues={{
                        ...JSON.parse(atividadeEditando.atividade),
                        codigoAtividade: atividadeEditando.codigo_atividade,
                      }}
                      modoEdicao={true}
                      readOnly={true}
                      closeModal={() => {
                        setModalEdicaoTipo(null);
                        setAtividadeEditando(null);
                      }}
                    />
                  }
                />
              );
          }
        })()}
    </>
  );
}
